exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_box[data-v-4ce5d796]{overflow:hidden}.des[data-v-4ce5d796]{font-size:.18rem;font-family:Roboto-Bold,Roboto;font-weight:bold;color:rgba(0,0,0,.85);line-height:.28rem;margin-bottom:.16rem}.total[data-v-4ce5d796]{font-size:.18rem;font-family:Roboto-Regular,Roboto;font-weight:400;color:rgba(0,0,0,.85);line-height:.28rem;margin-top:.16rem}.total span[data-v-4ce5d796]{color:#000}", ""]);

// exports
